import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { RegisterService } from '@inside-hub-app/customer-portal-b2c-client'
import { TranslateService } from '@ngx-translate/core'
import { NGXLogger } from 'ngx-logger'
import {
  KcDataService
} from '../../../kc-data.service'
import { KcTelephoneValidationViewData } from '../../../interfaces/kc-data.interface'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { SharedService } from '@inside-hub-app/customer-portal-shared'

@Component({
  selector: 'customer-portal-revolution-telephone-validation',
  templateUrl: './revolution-telephone-validation.component.html'
})
export class RevolutionTelephoneValidationComponent implements OnInit {
  constructor (
    private readonly kcDataService: KcDataService,
    private readonly registerService: RegisterService,
    private readonly translate: TranslateService,
    private readonly logger: NGXLogger,
    private readonly transifexTranslationsService: TranslationService,
    private readonly sharedService: SharedService
  ) {}

  @ViewChild('telephoneValidationForm', { static: true })
  private readonly formRef: ElementRef

  @ViewChild('code0', { static: true }) private readonly code0: ElementRef
  @ViewChild('code1', { static: true }) private readonly code1: ElementRef
  @ViewChild('code2', { static: true }) private readonly code2: ElementRef
  @ViewChild('code3', { static: true }) private readonly code3: ElementRef
  @ViewChild('code4', { static: true }) private readonly code4: ElementRef
  @ViewChild('code5', { static: true }) private readonly code5: ElementRef
  private codes: ElementRef[]

  public viewData: KcTelephoneValidationViewData

  public form = new FormGroup({
    code0: new FormControl<string | null>(null),
    code1: new FormControl<string | null>(null),
    code2: new FormControl<string | null>(null),
    code3: new FormControl<string | null>(null),
    code4: new FormControl<string | null>(null),
    code5: new FormControl<string | null>(null)
  })

  public code: string
  public resendDisabled = false

  focusFirstInput (): void {
    if (this.code0?.nativeElement) {
      this.code0.nativeElement.focus()
      this.code0.nativeElement.select()
    }
  }

  ngOnInit () {
    this.viewData =
      this.kcDataService.getViewData() as KcTelephoneValidationViewData
    this.codes = [
      this.code0,
      this.code1,
      this.code2,
      this.code3,
      this.code4,
      this.code5
    ]

    this.form.valueChanges.subscribe(value => {
      this.code =
        value.code0 +
        value.code1 +
        value.code2 +
        value.code3 +
        value.code4 +
        value.code5
      // submit only if all filled
      if (this.code.length === 6) {
        setTimeout(_ => {
          const formElement = this.formRef.nativeElement as HTMLFormElement
          formElement.submit()
          this.focusFirstInput()
        })
      }
    })
  }

  public keyup ($event: KeyboardEvent, index: number) {
    // focus last if not first
    if (
      index > 0 &&
      ($event.key === 'Backspace' || $event.key === 'ArrowLeft')
    ) {
      const element = this.codes[index - 1].nativeElement as HTMLInputElement
      element.focus()
      element.setSelectionRange(0, 1)
    }

    // focus next if not last
    if (
      index < this.codes.length - 1 &&
      Number.isInteger(parseInt($event.key))
    ) {
      const element = this.codes[index + 1].nativeElement as HTMLInputElement
      element.focus()
      element.setSelectionRange(0, 1)
    }
  }

  public focus (index: number) {
    const element = this.codes[index].nativeElement as HTMLInputElement
    if (!element.value) {
      element.value = '0'
    }

    // on focus select all
    if (element) {
      element.setSelectionRange(0, 1)
    }
  }

  isNumber (evt: KeyboardEvent): boolean {
    return this.sharedService.isNumber(evt)
  }

  public resend () {
    // enable after 1 minute
    this.resendDisabled = true
    setTimeout(() => {
      this.resendDisabled = false
    }, 60 * 1000)

    this.registerService
      .resendTelephoneVerification(
        this.viewData.telephoneNumber,
        null,
        this.translate.getDefaultLang()
      )
      .subscribe(
        res => {},
        error => {
          this.logger.log(error)
        }
      )
  }

  getTranslation1 (): string {
    return this.transifexTranslationsService.translate(
      'Enter the 6-digit code we just sent you <b>{phoneNumber}</b>.',
      {
        _key: 'customerPortal.kc.telephone-validation.text',
        _tags: 'kc-forms, 3.1',
        phoneNumber: this.viewData.telephoneNumber
      }
    )
  }

  getTranslation2 (): string {
    return this.transifexTranslationsService.translate(
      'Did not get the code?',
      {
        _key: 'customerPortal.kc.telephone-validation.resend',
        _tags: 'kc-forms, 3.1'
      }
    )
  }
}
